import { BoardOrientation } from "react-chessboard/dist/chessboard/types"

const formatResultForColor = (
  result: string | null,
  color: BoardOrientation
) => {
  if (!result || result === "*") return null

  const playerResult = result.split("-")[color === "white" ? 0 : 1]

  if (playerResult === "1/2") return "½"

  return playerResult
}

export default formatResultForColor
